<div class="annual-change-plan-container">
    <span *ngIf="annualPlan?.selected" class="selected-icon">
        <img alt="checkmark image" class="selected-icon-image"
             src="https://www-qa1.safeway.com/content/dam/DeliverySubscription/white.svg">
    </span>
    <p class="plan-type">{{annualPlan?.caption}}</p>
    <div class="sub-rectangle"></div>
    <h2 class="mt-2 value">{{annualPlan?.pricingDetailLine1}}</h2>
    <p class="first-text">{{programDisplayData?.annualPlan?.taxText}}{{annualPlan?.monthlyCost}}{{programDisplayData?.annualPlan?.monthText}}</p>
    <p class="renews">{{programDisplayData?.annualPlan?.renewelText}} {{annualAutoRenewsPrice}}.</p>
    <button 
      [ngClass]="isSnapVerified ? 'mt20' : ''"
      (click)="changePlanType(annualPlan?.code)" 
      *ngIf="!annualPlan?.selected" 
      class="select pds-btn pds-btn-filled--primary pds-btn-size__medium">
        {{programDisplayData?.annualPlan?.selectAnnual}}
    </button>
    <button *ngIf="annualPlan?.selected" aria-label="Current Plan" class="current">{{programDisplayData?.annualPlan?.currentPlan}}</button>
</div>
